import React, { useEffect, useState, useContext } from 'react';
import { back } from '../../helpers/dataServer';
import { UserContext } from '../auth/context/UserContext';

export const ListPerfiles = ({
  usuarioPerfil,
  onPerfilChange,
  modoMultiple,
}) => {
  const { dataUser } = useContext(UserContext);
  const [perfiles, setPerfiles] = useState([]);
  const { token } = dataUser;

  useEffect(() => {
    fetch(`${back}/perfiles/listperfiles`, {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => setPerfiles(data.data))
      .catch((error) =>
        console.error('Error al obtener la lista de perfiles:', error)
      );
  }, [token]);

  const handlePerfilChange = (perfilId) => {
    if (modoMultiple) {
      onPerfilChange(perfilId); // Llamar al manejador en el componente padre
    }
  };

  return (
    <div>
      {perfiles.map((perfil) => (
        <div key={perfil.id}>
          <input
            type="checkbox"
            id={`cbox-${perfil.id}`}
            value={perfil.id}
            checked={usuarioPerfil.includes(perfil.id)} // Verificar si el perfil está seleccionado
            onChange={() => handlePerfilChange(perfil.id)} // Llamar al cambio
          />
          <label htmlFor={`cbox-${perfil.id}`}>{perfil.denominacion}</label>
          <hr />
        </div>
      ))}
    </div>
  );
};
